import {GridColumns} from '@mui/x-data-grid';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';
import {RemoveUserFormLocationButton} from '../RemoveUserFormLocationButton';
import {CompanyChargerCount} from './CompanyChargerCount';
import {AppRouteEnum, AppRouteSpace} from '../../../utils/helper';
import {UserTypeEnum} from 'src/enums';

const deleteCol = (canDelete: boolean): GridColumns => {
    return canDelete
        ? [
            {
                field: 'remove',
                headerName: '',
                flex: 1,
                cellClassName: 'ampTableCell hoverableCell',
                renderCell: (params) => (
                    <RemoveUserFormLocationButton
                        userId={params.row.id}
                        isCompanyUser={params?.row?.user?.userType === UserTypeEnum.COMPANY}
                    />
                ),
            },
        ]
        : [];
};

export const columnConfig = (canCreateDeleteUsers = true, isEmployeeUser = false, locationId = 0, businessId = 0): GridColumns => [
    {
        field: 'id',
        renderHeader: (_params) => <FormattedMessage id={'idColumnHeader'}/>,
        flex: 1,
        cellClassName: 'ampTableCell',
    },
    {
        field: 'parkingPlace',
        renderHeader: (_params) => <FormattedMessage id={'parkingPlaceColumnHeader'}/>,
        flex: 3,
        cellClassName: 'ampTableCell',
        valueGetter: (params) => {
            if (params.row?.user?.parkingAddress?.parkingPlace) {
                return params.row.user.parkingAddress.parkingPlace;
            }

            if (params.row?.parkingAddress?.parkingPlace) {
                return params.row.parkingAddress.parkingPlace;
            }

            return <FormattedMessage id="na"/>;
        },
    },
    {
        field: 'firstName',
        renderHeader: (_params) => <FormattedMessage id={'clientColumnHeader'}/>,
        flex: 3,
        cellClassName: 'ampTableCell',
        renderCell: (params) => {
            let label = '';

            if (params?.row?.firstName && params?.row?.lastName) {
                label = `${params.row.firstName} ${params.row.lastName}`;
            }

            if (params?.row?.name) {
                label = `${params.row.name}`;
            }

            if (params?.row?.company?.name) {
                label = `${params.row.company.name}`;
            }

            if (isEmployeeUser) {
                return <span>{label}</span>;
            }

            return <Link to={`/app/users/${params?.row?.user?.id ?? params?.row?.id}`}>{label}</Link>;
        },
    },
    {
        field: 'chargePointId',
        renderHeader: (_params) => <FormattedMessage id={'chargePointIdColumnHeader'}/>,
        flex: 3,
        cellClassName: 'ampTableCell',
        renderCell: (params) => {
            // Company row — fetch charger count from API
            if (params.row.isCompanyRow) {
                return (
                    <CompanyChargerCount
                        companyId={params.row.id}
                        locationId={locationId}
                        businessId={businessId}
                    />
                );
            }

            // User row — show chargePoint link
            return params.row.chargePoint ? (
                <Link
                    to={AppRouteSpace([
                        AppRouteEnum.app,
                        AppRouteEnum.chargers,
                        String(params.row.chargePoint?.id),
                    ])}
                >
                    {`${params.row.chargePoint?.chargePointId}`}
                </Link>
            ) : (
                '-'
            );
        },
    },
    ...deleteCol(canCreateDeleteUsers),
];